<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t('view') }} {{ $t('usage') }} {{ $t('promotionsandoffer') }}</div>
      </div>
      <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <b-button variant="default" to="promotions-and-offers" class="btn-blue">{{ $tc('list', 1) }}</b-button>
      </div>
    </div>

    <div class="white-wrapper mt-3">
      <div
        class="mb-2 font-weight-bold"
      >{{ $t('total') }} {{ $tc('ticket', 1) }} {{ $t('sold') }} - {{Records.length}}</div>
      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th>{{ $t('promocode') }}</th>
              <th>{{ $tc('cinema', 1) }}</th>
              <th>{{ $tc('movie', 1) }} / {{ $tc('item') }} {{ $t('name') }}</th>
              <th>{{ $t('show') }} {{ $t('datetime') }}</th>
              <th>{{ $t('time') }} {{ $t('usage') }}</th>
              <th>{{ $t('client_name') }}</th>
              <th>{{ $t('client') }} {{ $t('shareValue') }}</th>
              <th>{{ $t('discount') }} {{ $t('amount') }}</th>
              <th>{{ $t('grossAmount') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(singleRecord, IndexKey) in Records" :key="IndexKey">
              <td>{{ singleRecord.promo_code || singleRecord.offer_title }}</td>
              <td>{{ singleRecord.cine_name || singleRecord.cinema_name }}</td>
              <td
                v-if="singleRecord.movie_title && singleRecord.movie_title.length > 0"
              >{{ singleRecord.movie_title || singleRecord.item_name }} ({{ singleRecord.mf_name }}) ({{ singleRecord.lang_name }})</td>
              <td v-else>{{ singleRecord.item_name }}</td>
              <td>
                {{ singleRecord.t_show_date | dateparse }}
                <br />
                {{ singleRecord.t_show_time }}
              </td>
              <td>
                {{ singleRecord.created_at | dateparse }}
                <br />
                {{ singleRecord.created_at | timeparse }}
              </td>
              <td>{{ singleRecord.client_name }}</td>
              <td>{{ singleRecord.client_share_value }}</td>
              <td>{{ singleRecord.t_offer_price || singleRecord.ft_offer_price }}</td>
              <td>{{ singleRecord.total_amount || singleRecord.ft_gross_amount_before_offer }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-pagination
      v-if="Records && Records.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>


<script>
import MarketingService from "@/services/MarketingService";
import moment from "moment";

export default {
  data() {
    return {
      roleID: "",
      os_id: "",
      Records: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
    };
  },

  beforeMount() {
    this.roleID = this.secureStore.get("USINFO").role_id;
    const { os_id } = this.$route.query;

    // this.getCountriesList();

    if (os_id) {
      this.getOfferUsageDetails(os_id);
    } else {
      const { os_id } = this.$route.query;
      this.os_id = this.$route.query.user_id;

      if (os_id) {
        this.getOfferUsageDetails(os_id);
      } else {
        this.$router.go(-1);
      }
    }
  },
  mounted() {},
  methods: {
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getOfferUsageDetails();
      } else {
        this.currentPage = event;
        this.getOfferUsageDetails();
      }
    },
    getOfferUsageDetails: function (os_id) {
      MarketingService.GetOfferUsage({
        os_id,
        limit: this.perPage,
        currentPage: this.currentPage,
      })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Records = data.Records;
            this.rows = data.totalRows;
          } else {
            this.$toasted.show("No Records found");
          }
        })
        .catch((error) => {
          this.$toasted.show("Catch Error on: ", error);
        });
    },
  },
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/viewUsagePromotionsAndOffers.vue